export default "__VITE_ASSET__m1caw50z__"